export const ROUTES = {
  ROOT: '/',
  CALLBACK: '/cb',
};
